import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useDeleteProfilePicture() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: () => del({ url: '/users/current/profile-picture' }),
    onSuccess: () => {
      // Clear the cached URL immediately so the UI updates without waiting for a refetch
      queryClient.setQueryData(queryKeys.getProfilePicture(), null);
      queryClient.invalidateQueries({ queryKey: queryKeys.getUser('current') });
    },
  });

  const deleteProfilePicture = useCallback(() => mutate(), [mutate]);

  return {
    deleteProfilePicture,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
